const eval_utils = {};

eval_utils.round = (what, decimals=2) => {
	return Math.round(( what + Number.EPSILON ) * ( 10 ** decimals )) / (10 ** decimals);
};

export const neo_eval = (value, type) => {
    if(typeof value !== 'string') {
        return value;
    }

    let has_js = /js\./g;
    let has_math = /\s[\+\-\/\*]\s/g; // eslint-disable-line no-useless-escape

    if(!has_js.test(value) && !has_math.test(value)) {
        return value;
    }

    if(value){
        // Define JS in the local eval scope
        const js = eval_utils; // eslint-disable-line no-unused-vars
        // Replace line jumps to allow multi-line keys
        // Replace 00s to prevent octal exception
        const to_eval = value.toString().replace(/\n/g, '').replace(/([\s-+%*(])00/g, '$10');
        try {
            value = eval(to_eval); // eslint-disable-line no-eval
        } catch(e) {
            console.error(e);
            value = value.toString();
        }
    }

    return value;
};
